import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { FeatureFlagService } from '../services/feature-flag.service';

@Directive({
  selector: '[diIsFeatureEnabled]',
})
@UntilDestroy()
export class IsFeatureEnabledDirective implements OnInit {
  @Input('diIsFeatureEnabled') flagName!: string;
  private hasView = false;

  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly featureFlagService = inject(FeatureFlagService);

  ngOnInit(): void {
    this.featureFlagService
      .getFlagValue(this.flagName)
      .pipe(untilDestroyed(this))
      .subscribe((toggleStatus) => this.updateView(toggleStatus === true));
  }

  private updateView(isShow: boolean) {
    if (isShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
